var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-card',{staticClass:"p-1"},[_c('form-component',{attrs:{"page":_vm.isnpirationSite},on:{"onSubmit":_vm.onSubmit,"fetchByLocale":_vm.fetchInspirationsSite}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }